import { FC } from 'react';
import Box from 'yoda-ui/Box';
import Button from 'yoda-ui/Button';
import { ButtonType } from 'yoda-ui/Button/Button.types';
import Dialog from 'yoda-ui/Dialogs/Dialog';
import DialogActions from 'yoda-ui/Dialogs/Dialog/DialogActions';
import DialogContent from 'yoda-ui/Dialogs/Dialog/DialogContent';
import DialogTitle from 'yoda-ui/Dialogs/Dialog/DialogTitle';
import { YodaSpacing } from 'yoda-ui/yodaTheme';

type ConfirmationDialogProps = {
  dialogTitle: string;
  dialogMessage?: string;
  onConfirmLabel: string | JSX.Element;
  onDismissLabel: string;
  onConfirm: () => void;
  onDismiss: () => void;
};

const ConfirmationDialog: FC<ConfirmationDialogProps> = ({
  children,
  dialogTitle,
  dialogMessage,
  onConfirmLabel,
  onDismissLabel,
  onConfirm,
  onDismiss,
}) => (
  <Dialog open maxWidth="md">
    <Box padding={ YodaSpacing.xLarge }>
      <DialogTitle>
        <Box textAlign="center" lineHeight="2rem">
          { dialogTitle }
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box marginBottom={ YodaSpacing.xLarge } textAlign="center" lineHeight="1.5rem">
          { children || dialogMessage }
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={ onDismiss } buttonType={ ButtonType.neutral }>
          { onDismissLabel }
        </Button>
        <Button onClick={ onConfirm } buttonType={ ButtonType.primary }>
          { onConfirmLabel }
        </Button>
      </DialogActions>
    </Box>
  </Dialog>
);

export default ConfirmationDialog;
